import axios from 'axios';

// Action Types
export const FETCH_CMS_DATA_REQUEST = 'FETCH_CMS_DATA_REQUEST';
export const FETCH_CMS_DATA_SUCCESS = 'FETCH_CMS_DATA_SUCCESS';
export const FETCH_CMS_DATA_FAILURE = 'FETCH_CMS_DATA_FAILURE';

// Action Creator
export const fetchCmsData = (cmsType, language) => async (dispatch) => {
  dispatch({ type: FETCH_CMS_DATA_REQUEST });

  try {
    const response = await axios.get(`${process.env.REACT_APP_API_KEY}/api/get-cms-details/${cmsType}/${language}`);
    dispatch({
      type: FETCH_CMS_DATA_SUCCESS,
      payload: response.data, // Set the response data to Redux
    });
  } catch (error) {
    dispatch({
      type: FETCH_CMS_DATA_FAILURE,
      payload: error.message || 'Failed to fetch CMS data',
    });
  }
};
